import React,{CSSProperties} from 'react';
import styled from 'styled-components';
import {Link as RLink} from 'react-router-dom';

type linkProps = {
    to?: string,
    href?: string,
    onClick?: any,
    style?: CSSProperties,
    className?: string,
    children?: any
}
const Anchor = (props:linkProps) =>
    props.to ?
        <RLink className={props.className + " noselect"} to={props.to} onClick={props.onClick} style={props.style}>{props.children && props.children}</RLink>
    :   
        <a className={props.className + " noselect"} href={props.href} onClick={props.onClick} style={props.style}>{props.children && props.children}</a>

const Link = styled(Anchor)`
    cursor: pointer;
`
export default Link;